/**
 * SxaAssessmentFinishTile.js
 *
 * Copyright (c) 2018-2019 i-Solutions Global Ltd. All Rights Reserved.
 *
 * This software is the confidential and proprietary information of
 * i-Solutions Global Ltd. ("Confidential Information").  You shall
 * not disclose such Confidential Information and shall use it only in
 * accordance with the terms of the license agreement you entered into
 * with i-Solutions Global Ltd.
 *
 * I-SOLUTIONS GLOBAL LTD MAKES NO REPRESENTATIONS OR WARRANTIES ABOUT
 * THE SUITABILITY OF THE SOFTWARE, EITHER EXPRESS OR IMPLIED, INCLUDING BUT NOT
 * LIMITED TO THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
 * PARTICULAR PURPOSE, OR NON-INFRINGEMENT. I-SOLUTIONS GLOBAL LTD SHALL NOT BE
 * LIABLE FOR ANY DAMAGES SUFFERED BY LICENSEE AS A RESULT OF USING, MODIFYING OR
 * DISTRIBUTING THIS SOFTWARE OR ITS DERIVATIVES.
 *
 * Version 1.0
 */

import React from 'react';
import PropTypes from 'prop-types';

import StratexReportThumbnail from "./images/inx_report.png";

import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Dialog from "@material-ui/core/Dialog";
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import axios from "axios";

const styles = theme => ({
    welcomelabel: {
        fontSize: 18,
        marginTop: 18,
        marginBottom: 0,
        marginLeft: 20,
        marginRight: 20,
        color: "white"
    },
    getstartedlabel: {
        fontSize: 14,
        marginTop: 4,
        marginBottom: 4,
        marginLeft: 20,
        marginRight: 20,
        color: "#1e2b56"
    },
    form: {
        display: 'flex',
        flexDirection: 'column',
        margin: 'auto',
        width: 'fit-content',
    },
    formControl: {
        marginTop: 0,
        minWidth: 100,
    },
    formControlLabel: {
        marginTop: 0,
        fontSize: 14,
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        fontFamily: 'Open Sans, sans-serif',
        fontSize: 16,
    },
    reportTitle: {
        fontSize: 15,
        fontFamily: 'Open Sans, sans-serif',
        fontWeight: "bold",
        marginBottom: 4,
        marginLeft: 8,
        color: "#1e2b56"
    },
    reportInstruction: {
        fontSize: 13,
        fontFamily: 'Open Sans, sans-serif',
        marginBottom: 4,
        marginLeft: 8,
        width: "95%",
        height: 50,
        color: "#1e2b56"
    },
    reportBody: {
        fontSize: 16,
        fontFamily: 'Open Sans, sans-serif',
        marginBottom: 4,
        color: "#1e2b56"
    },
});

class SxaAssessmentFinishTile extends React.Component {
    constructor(props) {
        super(props);
        // Assign A ref to state for refresh
        this.state = {
            ass: props.ass,
            openMessage: false,
            openNosend: false
        };

        this.handleSendClick = this.handleSendClick.bind(this);
    }

    handleCloseMessage = () => {
        console.log("AA " + this.state.ass.oid + " Finish dialog Confirmation closed");
        this.setState({ openMessage: false });

        // Reset the send report fields
        console.log("Clearing portrait Finish dialog field values");
        this.setState({ guestfirst: "", guestlast: "", company: "", email: "", checked: false });

        // Exit the Finish view
        this.props.signalFinishExit();
    };

    handleCloseNosend = () => {
        this.setState({ openNosend: false });

        // Exit the Finish view? - No, stay in
    };

    handleTextChange = name => event => {
        // email, company, guestfirst, guestlast
        //console.log("TextField change; name = " + name + "; value = " + event.target.value);
        this.setState({ [name]: event.target.value });
    };

    handleCheckChange = name => event => {
        // checked
        //console.log("Checkbox change; name = " + name + "; value = " + event.target.value);
        this.setState({ [name]: event.target.checked });
    };

    // Utility method to do simple validate email
    validateEmail(email) {
        var re = /\S+@\S+\.\S+/;
        return re.test(email);
    }

    handleSendClick = () => {
        console.log("Assessment SEND REPORT clicked");

        console.log("AA " + this.state.ass.oid + " Send Report, user details: " +
            " guestfirst = " + this.state.guestfirst +
            " guestlast = " + this.state.guestlast +
            " company = " + this.state.company +
            " email = " + this.state.email +
            " checked = " + this.state.checked
        );

        // Check if submit ok
        // Check submit conditions:
        // (a) consent given - checked = true
        // (b) mandatory fields entered - values for guest, company, email
        // FIXME - check email valid - presence of @?
        if (this.state.checked === true &&
            this.state.guestfirst && this.state.guestlast && this.state.company && this.state.email &&
            this.validateEmail(this.state.email) === true)
        {
            console.log("Assessment Send conditions met");
        }
        else {
            console.log("Assessment Send conditions not met; ignoring Send report");

            // Pop message dialog
            this.setState({ openNosend: true });
            return;
        }

        // Set the busy cursor
        document.body.style.cursor='wait';

        // Call the server with the 3 fields + the flag to finish and generate the report
        // FIXME - change to sxa/v1/assessment
        // FIXME - use GET instead of POST to workaround CORS bug in server
        // Replaced Axios version:
        var url = 'api/assessment/finish?guestfirst=' + this.state.guestfirst + '&guestlast=' + this.state.guestlast +
            '&org=' + this.state.company + '&email=' + this.state.email + '&consent=' + this.state.checked;
        axios.get(url)
            .then(response => {
                console.log(response.data);

                document.body.style.cursor='auto';

                // Confirmation message (pop 2nd dialog)
                this.setState({ openMessage: true });
            })
            .catch(err => {
                document.body.style.cursor='auto';
                console.error(err)
            })
    }

    render() {
        const {classes} = this.props;
        return (
            <React.Fragment>
                { this.state.ass ? (
                    <div style={{ paddingLeft: 10, paddingRight: 15,
                        paddingTop: 6, paddingBottom: 20, marginTop: 6}} >
                        <Grid container spacing={0} style={{padding: 0}}
                              direction="row" justify="space-evenly" alignItems="stretch">
                            <Grid item xs={12} sm={12} lg={12} xl={12}>
                            </Grid>
                            <Grid item xs={12} sm={12} lg={12} xl={12}>
                                <Grid container spacing={0} style={{padding: 0}}
                                      direction="row" justify="space-between" alignItems="stretch">
                                    <Grid item xs={9} sm={9} lg={9} xl={9}>
                                        <Typography align="left" className={classes.reportTitle} >
                                            FREE complimentary report
                                        </Typography>
                                        <Typography align="left" className={classes.reportInstruction} >
                                            To receive your report, please fill in this form and you will get a copy via email.
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={3} sm={3} lg={3} xl={3}>
                                        <img src={StratexReportThumbnail} alt="Thumb"
                                             align="right" width="70" style={{ marginTop: 6, marginRight: 6}}/>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} sm={12} lg={12} xl={12}>
                                <TextField
                                    id="outlined-namefirst"
                                    onChange={this.handleTextChange('guestfirst')}
                                    label="Enter First Name*"
                                    className={classes.textField}
                                    variant="outlined"
                                    margin="dense"
                                    style={{ width: "95%"}}
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} lg={12} xl={12}>
                                <TextField
                                    id="outlined-namelast"
                                    onChange={this.handleTextChange('guestlast')}
                                    label="Enter Last Name*"
                                    className={classes.textField}
                                    variant="outlined"
                                    margin="dense"
                                    style={{ width: "95%"}}
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} lg={12} xl={12}>
                                <TextField
                                    id="outlined-company"
                                    onChange={this.handleTextChange('company')}
                                    label="Enter Company*"
                                    className={classes.textField}
                                    variant="outlined"
                                    margin="dense"
                                    style={{ width: "95%"}}
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} lg={12} xl={12}>
                                <TextField
                                    id="outlined-email"
                                    onChange={this.handleTextChange('email')}
                                    label="Enter Email*"
                                    className={classes.textField}
                                    type="email"
                                    name="email"
                                    autoComplete="email"
                                    variant="outlined"
                                    margin="dense"
                                    style={{ width: "95%"}}
                                    helperText="* Mandatory fields"
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} lg={12} xl={12}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            // Controlled component? checked={this.state.checked}
                                            onChange={this.handleCheckChange('checked')}
                                            value="checked"
                                            color="primary"
                                        />
                                    }
                                    className={classes.formControlLabel}
                                    label={<Typography style={styles.formControlLabel} >
                                        I consent to receiving i-nexus marketing material
                                        </Typography>
                                    }
                                    labelPlacement="start"
                                    style={{ width: "95%", color: "#1e2b56", align: "right"}}
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} lg={12} xl={12}>
                                <Button onClick={this.handleSendClick} variant="contained"
                                        color="primary"
                                        align="right"
                                        style={{
                                            marginTop: 2,
                                            marginBottom: 32,
                                            backgroundColor: '#1976D2'
                                        }}>
                                    Send report
                                </Button>
                            </Grid>
                        </Grid>

                        <Dialog
                            open={this.state.openMessage}
                            onClose={this.handleCloseMessage}
                            aria-labelledby="max-width-dialog-title"
                            maxWidth="lg"
                        >
                            <DialogTitle id="simple-dialog-title">Your FREE complimentary report has been sent</DialogTitle>
                            <DialogContent>
                                <Typography align="left" className={classes.reportBody} >
                                    Thank you for completing the assessment.
                                </Typography>
                            </DialogContent>
                        </Dialog>

                        <Dialog
                            open={this.state.openNosend}
                            onClose={this.handleCloseNosend}
                            aria-labelledby="max-width-dialog-title"
                            maxWidth="lg"
                        >
                            <DialogTitle id="simple-dialog-title">Your FREE complimentary report was NOT sent</DialogTitle>
                            <DialogContent>
                                <Typography align="left" className={classes.reportBody} >
                                    Please complete all fields including consent.
                                </Typography>
                            </DialogContent>
                        </Dialog>
                    </div>
                ) : "No Assessment found"}
            </React.Fragment>
        );
    }
}

/*
Old div bg color
background: "#e6eaee",

<Typography align="left" className={classes.reportBody} >
    Click out of this dialog return to the Assessment view.
</Typography>
 */

SxaAssessmentFinishTile.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SxaAssessmentFinishTile);